export const TRANSLATIONS_DE = {
  join_eui: "Join EUI",
  app_key: "App Key",
  email: "E-Mail",
  password: "Passwort",
  address: "Adresse",
  forgotpassword: "Passwort vergessen? ",
  email_field_is_required: "E-Mail-Feld ist erforderlich",
  reset_password: "Passwort zurücksetzen",
  password_field_is_required: "Passwort-Feld ist erforderlich",
  password_do_not_match: "Passwort stimmt nicht überein",
  invalid_email_address: "Ungültige E-Mail-Adresse",
  leave_empty_to_keep_current: "Leer lassen, um das aktuelle Passwort zu behalten",
  enter_email_address: "E-Mail Adresse eingeben",
  create_account: "Konto erstellen",
  dont_have_an_account: "Sie haben kein Konto?",
  already_have_an_account: "Sie haben bereits ein Konto?",
  back_to_login: "Zurück zum Login",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Geben Sie die mit Ihrer verknüpfte E-Mail-Adresse ein	Konto und wir senden Ihnen einen Link zum Zurücksetzen	Ihr Passwort.",
  nav: {
    dashboard: "Dashboard",
    inventory: "Inventar",
  },
  inventory: "Inventar",
  inventory_title: "Inventarverwaltung",
  add_inventory_item: "Artikel hinzufügen",
  edit_inventory_item: "Artikel bearbeiten",
  current_stock: "Aktueller Bestand",
  low_stock_threshold: "Meldebestand",
  low_stock_only: "Nur geringer Bestand",
  unit_of_measure: "Einheit",
  purchase_link: "Kauflink",
  batch_update_save: "Änderungen speichern",
  batch_update_success: "Inventar erfolgreich aktualisiert",
  item_created_success: "Artikel erfolgreich erstellt",
  item_updated_success: "Artikel erfolgreich aktualisiert",
  item_deleted_success: "Artikel erfolgreich gelöscht",
  item_delete_confirm: "Sind Sie sicher, dass Sie diesen Artikel löschen möchten?",
  dashboard: {
    title: "Produktions-Dashboard",
    total_produced: "Gesamt produziert",
    qc_passed_unassigned: "Aktueller Bestand",
    all_time: "Gesamte Zeit",
    current_year: "Aktuelles Jahr",
    all_quarters: "Alle Quartale",
    usage_distribution: "Nutzungsverteilung",
    production_volume: "Produktionsvolumen",
    qc_passed_only: "Nur bestandene Qualitätskontrolle",
  },
  logout: "Abmelden",
  user: "Benutzer:in",
  users: "Benutzer:innen",
  username: "Benutzername",

  save: "Speichern",
  name: "Name",

  login: "Anmeldung",
  signup: "Registrierung",
  delete: "Löschen",
  edit: "Bearbeiten",
  projects: "Projekte",
  trees: "Bäume",
  customers: "Kund:innen",
  customer: "Kund:in",
  confirm: "Bestätigen",

  sensor_details: {
    empty_sensors: "Kein Sensor, bitte beginnen Sie mit dem Hinzufügen von Sensoren.",
    no_sensor_selected: "Bitte Sensor auswählen, um Details anzuzeigen",
    no_data_found: "Keine Sensordaten gefunden",
  },
  sensors: "Sensoren",
  actions: "Aktionen",
  battery: "Batterie",

  threshold: "Grenzwert",
  settings: "Einstellungen",
  notifications: "Benachrichtigungen",

  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "Die eindeutige Identifikation des Sensors. Sie befindet sich auf dem Aufkleber auf dem Sendemodul. Für LoRaWAN Sensoren handelt es sich um die DevEUI und für NB-IoT Sensoren um die IMEI.",
  imei: "IMEI",
  add_sensor: "Sensor hinzufügen",
  add_user: "Benutzer hinzufügen",
  edit_user: "Benutzer bearbeiten",
  edit_sensor: "Sensor bearbeiten",

  email_notification: "E-Mail-Benachrichtigungen",
  email_schedule: "E-Mail-Zeitplan",
  weekly_summary_email: "Wöchentliche Zusammenfassung per E-Mail",
  daily_changes_email: "Tägliche Änderungs-E-Mail",
  manage_users_description: "Benutzerkonten und Berechtigungen verwalten",
  manage_customers_description: "Kundeninformationen und Zugriff verwalten",
  statistics: "Statistiken",
  customer_statistics_description: "Kundenstatistiken und Datenübersicht anzeigen",

  sensor_status_change_to_no_connection: "Sensorstatusänderung: Grau/kein Datenempfang",
  sensor_status_change_to_dry: "Sensorstatusänderung: Rot/Trockenstress",
  sensor_status_change_to_drying_out: "Sensorstatusänderung: Gelb/Leichter Trockenstress",

  error: {
    this_field_is_required: "Dieses Feld ist erforderlich",
    something_went_wrong: "Etwas ist schiefgelaufen",
    loading_customers: "Fehler beim Laden der Kunden",
    loading_users: "Fehler beim Laden der Benutzer",
  },
  error_label: "Fehler",
  first_name: "Vorname",
  last_name: "Nachname",
  profile: "Profil",

  phone_number: "Telefonnummer",
  account_type: "Kontotyp",
  city: "Stadt",
  street_name: "Straße",
  house_number: "Hausnummer",
  country: "Land",
  zip_code: "Postleitzahl",
  day: {
    mon: "Montag",
    tue: "Dienstag",
    wed: "Mittwoch",
    thu: "Donnerstag",
    fri: "Freitag",
    sat: "Samstag",
    sun: "Sonntag",
  },
  admin: "Admin",
  basic: "Basis",
  superuser: "Superuser",
  export: "Exportieren",
  select_customer_type: "Kundentyp wählen",
  customer_type: "Kundentyp",
  change_image: "Bild ändern",
  update_image: "Bild aktualisieren",
  update_customer_logo_description: "Laden Sie Ihr Firmenlogo hoch und aktualisieren Sie es",
  change_language: "Sprache ändern",
  total_trees: "Gesamtzahl der Bäume",
  time: "Zeit",

  write_some_notes_on_action_performed:
    "Schreiben Sie einige Notizen zur durchgeführten Aktion ...",
  resistance: "Widerstand",
  search_sensor: "Sensorsuche",
  download_sensor_data: "Sensordaten herunterladen",
  temperature: "Temperatur",
  loading: "Laden ...",
  button: {
    back: "Zurück",
    next: "Weiter",
    save: "Speichern",
    reset: "Zurücksetzen",
    saving: "Speichern ...",
    update: "Aktualisieren",
    updating: "Aktualisieren ...",
    add_sensor: "Sensor hinzufügen",
    add_customer: "Kunde hinzufügen",
    edit_customer: "Kunden bearbeiten",
    cancel: "Abbrechen",
    discard: "Verwerfen",
  },
  user_form: {
    profile: "Profil",
    address: "Adresse",
    basic_info: "Grundlegende Informationen",
    login_credentials: "Anmeldedaten",
    areas: "Bewässerungsbereiche",
  },
  sensor_form: {
    name: "Name",
    threshold: "Schwellenwert",
    hardware_serial: "DevEUI/IMEI",
    sensor_type: "Sensortyp",
    network_type: "Netzwerktyp",
  },
  network_type: "Netzwerktyp",
  sensor_type: "Sensortyp",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  area_form: {
    existing_area: "Bestehender Bereich",
  },
  add_all_form: {
    title: "Baum mit Sensor in Bereich hinzufügen",
    sensor: {
      title: "Sensor",
      explanation:
        "Hier kann ein neuer Sensor erstellt und dem Baum hinzugefügt werden. Oder aber ein bereits bestehender Sensor kann ausgewählt werden, um ihn dem hinzuzufügen.",
      new_sensor: "Erstelle einen neuen Sensor",
      existing_sensors: "Bestehende Sensoren hinzufügen",
    },
    tree: {
      title: "Baum",
      explanation: "Hier kann ein neuer Baum erstellt oder ein bestehender ausgewählt werden.",
      new_tree: "Erstelle einen neuen Baum",
      existing_tree: "Wähle einen bestehenden Baum aus",
    },
    area: {
      title: "Bereich",
      explanation:
        "Hier kann ein neuer Bereich erstellt oder ein bestehender ausgewählt werden, welchem der Baum hinzugefügt werden soll.",
      new_area: "Neuen Bereich erstellen",
      existing_area: "Bestehenden Bereich auswählen",
    },
  },

  new_area: "Neuer Bereich",
  existing_area: "Bestehender Bereich",
  explanation: "Erklärung",
  create_new_tree: "Neuen Baum erstellen",
  validation: {
    email_is_required: "E-Mail ist erforderlich",
    password_is_required: "Passwort ist erforderlich",
    invalid_email_address: "Ungültige E-Mail-Adresse",
    name_is_required: "Name ist erforderlich",

    hardware_serial_is_required: "Hardware-Seriennummer ist erforderlich",
    user_with_this_email_already_exist: "Benutzer mit dieser E-Mail-Adresse existiert bereits",
    all_address_field_are_required: "Alle Adressfelder sind erforderlich",
    position_is_required: "Position ist erforderlich",
    invalid_house_number: "Ungültige Hausnummer",
    user_limit_exceeded_for_your_package: "Benutzerlimit für Ihr Paket überschritten",
    sensor_limit_exceeded_for_your_package: "Sensorlimit für Ihr Paket überschritten",
    imei_must_be_15_digits: "IMEI muss genau 15 Ziffern enthalten.",
    hardware_serial_must_be_16_characters:
      "Die Hardware-Seriennummer muss genau 16 Zeichen lang sein.",
    must_be_a_number: "Der Wert muss eine Zahl sein",
    out_of_range: "Der Wert muss zwischen {{min}} und {{max}} liegen",
  },
  drag_the_below_variables_to_graph_area:
    "Ziehen Sie die folgenden Variablen in den Diagrammbereich",
  drop_left: "Drop Left",
  drop_right: "Drop Right",
  drop_the_variable_to_get_data: "Lassen Sie die Variable fallen. Mach weiter!",
  no_data_available_please_check_data_available_to_this_date:
    "Keine Daten verfügbar, bitte überprüfen Sie die bis zu diesem Datum verfügbaren Daten",
  unable_to_upload_file: "Datei kann nicht hochgeladen werden",
  file_upload_successfully: "Datei wurde erfolgreich hochgeladen",
  no_tree_is_selected: "Kein Baum ausgewählt",
  no_sensor_is_selected: "Kein Sensor ausgewählt",

  areaName: "Name",
  childTree: "Untergeordneter Baum",
  add_child_tree: "Untergeordneten Baum hinzufügen",
  parentTree: "Übergeordneter Baum",
  area: "Bereich",
  areas: "Bereiche",
  add_area: "Bereich erstellen",

  start_with_adding_new_project: "Beginnen Sie mit dem Hinzufügen eines neuen Projekts",
  resis_temp_comp: "ResisTempComp",
  health_of_tree_is_good: "Gesundheitszustand des Baums ist gut",
  health_of_tree_is_drying_out: "Gesundheit des Baums trocknet aus",
  health_of_tree_is_poor: "Gesundheit des Baums ist schlecht",
  sensor_disconnect: "Sensor getrennt",
  battery_full: "Batterie voll",
  battery_empty: "Batterie leer",
  maintenance_needed: "Wartung notwendig",
  All: "Alle",

  less_than_60_of_the_battery_remaining: "Weniger als 60 % der verbleibenden Batterie",
  battery_is_getting_low: "Batterie wird schwach",
  size: "Größe",
  type: "Typ",
  map_view: "Kartenansicht",
  records: "Aufzeichnungen",
  status: "Status",
  tree_count: "Anzahl Bäume",

  welcome_back: "Willkommen zurück!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Sieht so aus, als hätten Sie keinen ausgewählten Bereich. Bitte wählen Sie einen Bereich aus, um Daten zu erhalten.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Sieht so aus, als hätten Sie keinen Baum ausgewählt. Bitte wählen Sie einen Baum aus, um Daten zu erhalten.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Sieht so aus, als hätten Sie keinen ausgewählten Sensor. Bitte wählen Sie einen Sensor aus, um Daten abzurufen.",
  please_drag_the_variable_to_display_data: "Bitte ziehen Sie die Variable, um Daten anzuzeigen.",

  click_on_marker_to_select_tree: "Marker anklicken, um Baum auszuwählen",
  next_irrigation: "Nächste Bewässerung",
  mean: "Mittelwert",
  sensor_state: "Sensorstatus",
  state: "Status",
  // moisture_content: "Feuchtigkeitsgehalt",
  moisture_content: "Treesense Feuchtigkeitsindex",
  card_number: "Kartennummer",
  card_name: "Kartenname",

  expiration_date: "Ablaufdatum",
  continue: "Weiter",
  today: "Heute",
  tomorrow: "Morgen",
  days_left: "noch Tage",
  days: "Tage",
  personal_data: "Persönliche Daten",
  language: "Sprache",
  saved: "Gespeichert",
  payment: "Zahlung",
  benifits: "Vorteile",
  change_logo: "Logo ändern",
  role: "Rolle",
  demo_project_warning: {
    title: "Demo Account",
    description:
      "Sie nutzen gerade einen Demo Account und haben nur wenige Rechte.\nWenn Sie bereits Kunde sind und Zugang zu Ihrem Kundenkonto haben möchten, kontaktieren Sie bitte den Support: support@treesense.net.\nFalls Sie noch kein Kunde sind, können Sie über unseren Shop auf https://www.treesense.net Sensoren bestellen.",
  },
  image_upload_info: {
    title: "Upload von Baumbildern möglich",
    description:
      "Um unsere Baumgesundheitsformel auf Ihre Bäume zu optimieren, bieten wir in der Baumliste die Möglichkeit an Bilder von Ihrem Baum hochzuladen.",
  },
  add_tree_img: "Baumbilder hochladen",
  datetime_photo: "Aufnahmezeitpunkt des Bilds",
  upload_tree_img: "Baumbild hochladen",
  upload_leaf_img: "Blattbild hochladen",
  pulse_sensor: "Kronensensor",
  soil_moisture_sensor: "Bodenfeuchtesensor",
  soil_moisture: "Bodenfeuchte",
  soil_water_tension_sensor: "Bodensaugsspannungssensor",
  soil_water_tension: "Bodensaugsspannung",
  dendrometer_sensor: "Dendrometer",
  here: "hier",

  manual: {
    sign_up: {
      title: "Registrierung",
      list: {
        1: "Auf cloud.treesense.net registrieren",
        2: "Dem [Kundensupport](mailto:support@treesense.net) Bescheid geben",
      },
    },
    add_sensor: {
      title: "Anlegen eines Sensors/Projekts",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    view_data: {
      title: "Sensordaten ansehen",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    irrigation: {
      title: "Nächste Bewässerung",
      list: {
        1: "",
        2: "",
        3: "",
      },
    },
    api: {
      title: "Schnittstelle/API",
      description:
        "Die Dokumentation zur Schnittstelle kann [hier](https://api.treesense.net/docs) aufgerufen werden.",
    },
  },
  views_per_page: "Besuche pro Seite",
  customer_attributes: "Kundenattribute",
  paid: "bezahlt",
  maintenances: "Pflegearbeiten",
  add_maintenance: "Plegearbeit hinzufügen",
  list_maintenances: "Liste bisheriger Wartungen",
  tree_profile: {
    tree_species_knowledge: "Fakten",
    tree_species: "Wissenswertes",
    tree_info: "Bauminformationen",
    want_to_know_more: "Möchten Sie mehr erfahren?",
    learn_more: "Klicken Sie hier, um mehr zu erfahren",
  },
  root_system: {
    UN: "Unbekannt",
    SH: "Flachwurzler",
    DE: "Tiefwurzler",
    HE: "Herzwurzler",
  },
  latin_name: "lat. Name",
  german_name: "dt. Name",
  tree_species: "Baumart",
  depth: "Tiefe",
  not_sending: "Sendet nicht",
  working: "Funktioniert",
  unknown: "Unbekannt",
  amount_nodes: "Anzahl Sensorknoten",
  add_installation: "Installation erstellen",
  select_sensor: "Sensor auswählen",
  select_depth: "Tiefe auswählen",
  installed_at: "Datum der Montage",
  removed_at: "Datum der Demontage",
  last_battery: "Letzter Batteriewert",
  characters: "Zeichen",
  maximum_of: "Maximal",
  stop_scanning: "Scannen Beenden",
  last_measurements: "Letzte Messwerte",
  adjust_thresholds_crown: "Grenzwerte für Pulse Feuchtigkeitsindex anpassen",
  adjust_thresholds_soil: "Grenzwerte für Bodensensoren anpassen",
  set_default: "Werte zurücksetzen",
  meaning_measurement: "Bedeutung der Sensorwerte",
  download_tree_list: "Baumliste herunterladen (.xlsx)",
  download_tree_details: "Details der Bäume herunterladen (.pdf)",
  not_provided: "Nicht eingetragen",
  soil_moisture_edit: "Grenzwerte vol. Bodenfeuchte",
  soil_water_tension_edit: "Grenzwerte Bodensaugspannung",
  select_language: "Sprache Auswählen",
  hardware_serial_no: "DevEUI",
  required_information: "* Erforderliche Informationen",
  download_project_data: "Alle Sensordaten des Projekts herunterladen",
  download_csv: "Projektdaten herunterladen (tsv-Dateien)",
  include_calculated_values: "Berechnete Werte herunterladen",
  calculated_values_wip:
    "Die Berechneten Werte (moisture_content, resis_temp_comp) werden momentan angepasst und sollten generell nicht als Messwerte, sondern als Interpretationshilfe verstanden werden.",
  last_10_measurements: "Letzte 10 Messwerte",
  soil_name: "Bodenname",
  optional_soil_name: "Optionaler Bodenname",
  tree_name: "Baumname",
  soil: "Boden",
  permanent_wilting_point: "Permanenter Welkepunkt",
  effective_field_capacity: "Nutzbare Feldkapazität",
  field_capacity: "Feldkapazität",

  sensor_status: "Sensor Status",
  sensor_status_description:
    "Der Sensor Status gibt an, ob der Sensor funktioniert oder ob er bspw. gewartet werden muss.",
  variables: "Variablen/Werte",
  download_success: "Download erfolgreich.",
  download_failed: "Download fehlgeschlagen. Bitte versuche es erneut.",
  timeframe: "Zeitraum",
  timeframe_hint:
    "Unverändert lassen, um die letzten 30 Tage herunterzuladen. Passe den Zeitraum an, um den Export einzuschränken.",
  invalid_date_range: "Das Startdatum muss vor dem Enddatum liegen.",

  // Sensor Lookup translations
  sensor_list: "Sensor Liste",
  sensor_lookup: "Produktion",
  tui_part: "TUI Teil",
  enter_tui_part_placeholder: "Teil der TUI eingeben (z.B. A84041AA)",
  tui_search_help: "Geben Sie einen Teil der Sensor-TUI ein, um zu suchen",
  searching: "Suchen...",
  search: "Suchen",
  no_sensors_found: "Keine Sensoren gefunden",
  sensor_not_found: "Sensor nicht gefunden",
  sensor_not_found_message: "Es wurde kein Sensor mit dem angegebenen TUI-Teil gefunden.",
  customer_not_found: "Kunde nicht gefunden",
  customer_not_found_message:
    "Es wurde kein Kunde mit der angegebenen Cloud-ID oder dem Namen gefunden.",
  last_sensor_event: "Letztes Sensor-Event",
  multiple_sensors_found: "Mehrere Sensoren gefunden",
  multiple_sensors_found_message:
    "Mehrere Sensoren entsprechen Ihrer Suche. Bitte klicken Sie auf eine der TUIs unten, um sie auszuwählen",
  sensor_events: "Sensor Ereignisse",
  no_sensor_events_found: "Keine Sensor-Ereignisse für diesen Sensor gefunden.",
  qc_passed: "QC Bestanden",
  passed: "Bestanden",
  failed: "Fehlgeschlagen",
  comments: "Kommentare",
  tui: "TUI",
  created_at: "Erstellt am",
  create_customer: "Kunden erstellen",
  customer_info: "Kundeninformationen",
  assign_sensor: "Sensor verknüpfen",
  enter_domain: "Domain eingeben",
  enter_name: "Namen eintragen",
  package: "Paket",
  customer_name_or_cloud_id: "Kunden-ID oder -name",
  enter_customer_name: "Kunden-ID oder -namen eingeben",
  enter_customer_name_or_cloud_id: "Geben Sie den Kundennamen oder die Cloud-ID ein",
  usage: "Nutzungsart",
  enter_cloud_id: "Gebe die Cloud-ID ein.",
  lorawan_keys: "LoRaWAN Keys",
  cloud_id: "Cloud-ID",
  fetch: "Laden",
  fetching: "Wird geladen...",
  no_lorawan_keys_found: "Keine LoRaWAN Keys gefunden.",
  leih: "Leihgabe",
  none: "Keine",
  qr_Scanner: "QR-Scanner",
  selectcamera: "Kamera auswählen",
  sensorevent: "Sensorereignis",
  creating: "Wird erstellt",
  customer_created_successfully: "Kunde erfolgreich erstellt",
  customer_creation_failed: "Kundenerstellung fehlgeschlagen",
  customer_creation_code: "Kundenerstellungs-Code",
  customer_name: "Kundenname",
  customer_sensors: "Kundensensoren",
  domain: "Domain",
  enter_comments: "Kommentare eingeben",
  last_created_customer: "Zuletzt erstellter Kunde",
  lorawan_keys_fetch_failed: "Abrufen der LoRaWAN-Schlüssel fehlgeschlagen",
  lorawan_keys_list: "Liste der LoRaWAN-Schlüssel",
  lost: "Verloren",
  no_change: "Keine Änderung",
  not_found: "Nicht gefunden",
  projects_views: "Projekte",
  rented: "Vermietet",
  replaced: "Ersetzt",
  research: "Forschung",
  sensor_assigned_successfully: "Sensor erfolgreich zugewiesen",
  sensor_assignment_failed: "Sensorzuweisung fehlgeschlagen",
  sensors_views: "Sensoren",
  sold: "Verkauft",
  assigned_from_date: "Zugewiesen ab (optional)",
  assigned_from_date_help: "Leer lassen, um ab heute zu starten",
  assigned_until_date: "Zugewiesen bis (optional)",
  assigned_until_date_help: "Leer lassen für unbefristete Zuweisung",
  optional: "Optional",
  search_sensors: "Sensoren nach Name, DevEUI oder IMEI suchen...",
  showing_results: "{{count}} Ergebnis(se) anzeigen",
  close: "Schließen",
  more_actions: "Mehr Aktionen",
  start_scanning: "Scannen starten",
  trees_views: "Bäume",
  unknown_customer: "Unbekannter Kunde",
  update_sensor_values: "Sensorwerte aktualisieren",
  download: "Download",
  sensor_return: "Sensor eingeschickt",
  sensor_return_title: "Sensor zurück ins Lager",
  sensor_return_description:
    "Entknüpfen Sie einen Sensor vom aktuellen Kunden, indem Sie das Rückgabedatum festlegen. Dies beendet automatisch die aktuelle Zuweisung.",
  sensor_return_tui_help: "Geben Sie die TUI ein, um den Sensor zu identifizieren",
  return_date: "Rückgabedatum",
  return_date_help: "Datum, an dem der Sensor zurückgegeben wurde",
  return_date_help_default_today:
    "Datum, an dem der Sensor zurückgegeben wurde, wenn leer gelassen, wird das heutige Datum verwendet",
  unassign_sensor: "Sensor zurückgeben",
  sensor_returned_successfully: "Sensor erfolgreich zurückgegeben",
  sensor_return_failed: "Sensor konnte nicht zurückgegeben werden",
  success: "Erfolg",
  currently_assigned_to: "Derzeit zugewiesen an",
  assigned_since: "Zugewiesen seit",
  sensor_not_assigned_to_customer: "Dieser Sensor ist derzeit keinem Kunden zugewiesen.",
  manage_customers: "Kunden verwalten",
  customer_details: "Kundendetails",
  customer_id: "Kunden-ID",
  total_sensors: "Sensoren insgesamt",
  total_probes: "Sonden insgesamt",
  customer_sensors_list: "Kunden-Sensoren-Liste",
};
